const questions = [
    { 
        qid: 'q1',
        question: 'Which team will win the tournament?',
        hint: 'Select the winning team:',
        answerOptions: ['all-teams'],
        answerCategory: 'select-team',
    },/*
    { 
        qid: 'q2',
        question: 'Which team will end as number third?',
        hint: 'Select the team that will end as third:',
        answerCategory: 'select-team',
    },*/
    { 
        qid: 'q2',
        question: 'Which team will be the first winner of a match this tournament?',
        hint: 'Select the team that will win a first match:',
        answerOptions: ['all-teams'],
        answerCategory: 'select-team',
    },
    { 
        qid: 'q3',
        question: 'Which team will have the most points after the group stage?',
        hint: 'Select the team with the most points after the group stage:',
        answerOptions: ['all-teams'],
        answerCategory: 'select-team',
    },
    { 
        qid: 'q4',
        question: 'Which team will receive the most yellow cards?',
        hint: 'Select the team that will receive the most yellow cards:',
        answerOptions: ['all-teams'],
        answerCategory: 'select-team',
    },
    { 
        qid: 'q5',
        question: 'Which team will be the first to win a match on penalties?',
        hint: 'Select the team that will be the first to win a match on penalties:',
        answerOptions: ['all-teams'],
        answerCategory: 'select-team',
    },
    { 
        qid: 'q6',
        question: 'Which team will score the fastest goal of the tournament?',
        hint: 'Select the team that will score the fastest goal of the tournament:',
        answerOptions: ['all-teams'],
        answerCategory: 'select-team',
    },
    { 
        qid: 'q7',
        question: 'Which team will suffer the biggest defeat?',
        hint: 'Select the team that will suffer the biggest defeat:',
        answerOptions: ['all-teams'],
        answerCategory: 'select-team',
    }
]
  
export default questions